<template>
  <v-container class="fill-height login" fluid>
    <v-row align="center" justify="start" class="login-box">
      <v-col cols="12">
        <login-card
          :email.sync="email"
          :password.sync="password"
          :sites="sites"
          :loading="loading"
          :failed="failed"
          :show-q-r="showQR"
          :route-name="routeName"
          :lang-list="langList"
          @login="login"
          @toggle-qr="handleToggleQR"
          @qr-decode="onDecode"
          @show-support="handleShowSupport"
        />
      </v-col>
    </v-row>

    <!-- Register Dialog Component -->
    <register-dialog
      v-model="showRegisterDialog"
      @user-registered="handleUserRegistered"
    />

    <!-- Restaurant Selection Dialog Component -->
    <restaurant-selection-dialog
      v-model="showRestaurantDialog"
      :restaurants="allRestorants"
      :new-user="newUser"
      :user-data="newUser.userData || { email: '', password: '' }"
      @restaurant-selected="handleRestaurantSelected"
    />
    <!-- Support Info Dialog Component -->
    <support-info-dialog v-model="showSupportDialog" />
  </v-container>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import conf from "@/config";
import setLang from "@/mixins/setLang";
import restaurantService from "@/services/restaurant";
import userService from "@/services/user";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import LoginCard from "@/components/login/LoginCard.vue";
import RegisterDialog from "@/components/dialogs/RegisterDialog.vue";
import RestaurantSelectionDialog from "@/components/dialogs/RestaurantSelectionDialog.vue";
import SupportInfoDialog from "@/components/dialogs/SupportInfoDialog.vue";

export default {
  mixins: [setLang, hasValidation, hasSnackbar],
  components: {
    QrcodeStream,
    LoginCard,
    RegisterDialog,
    RestaurantSelectionDialog,
    SupportInfoDialog,
  },
  data() {
    return {
      city: "",
      conf: conf,
      showSupportDialog: false,
      showRegisterDialog: false,
      showRestaurantDialog: false,
      email: null,
      password: null,
      sites: [],
      loading: false,
      failed: false,
      showQR: false,
      routeName: "",
      calculatedQr: {
        arr: [],
        status: true,
        json: null,
      },
      allRestorants: "",
      newUser: "",
      domain: window.location.origin.split("//")[1],
      countries: "",
      cities: [],
      langList: [
        { code: "sr", name: "Српски" },
        { code: "rs-lat", name: "Latinica" },
        { code: "hr", name: "Hrvatski" },
        { code: "bs", name: "Bosanski" },
        { code: "en", name: "English" },
        { code: "mk", name: "Македонски" },
        { code: "si", name: "Slovenščina", cir_to_lat: 0 },
      ],
    };
  },

  created() {
    this.getAllRestorans();
    this.getCountry();
    this.getLang();
  },
  methods: {
    clearCache() {
      if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          command: "clearCache",
        });
      }
    },
    hasGroupGoodMenu(companies) {
      if (companies && companies.length && companies[0].type === "group_food") {
        return true;
      }
    },
    hasGroupMenu(companies) {
      if (companies && companies.length && companies[0].type === "group") {
        return true;
      }
    },
    getCountry() {
      restaurantService.getCountriesAll().then(({ data }) => {
        this.countries = data;
      });
    },
    handleRestaurantSelected({ restaurant, userData }) {
      this.showRestaurantDialog = false;
      this.login2(userData.email, userData.password);
    },
    getAllRestorans() {
      restaurantService.getAllRestaurantsPublic().then(({ data }) => {
        this.allRestorants = data.data;
        (this.allRestorants || []).filter((res) => {
          (this.countries || []).filter((con) => {
            if (con.city) {
              con.city.filter((city) => {
                if (city.id == res.city_id) {
                  this.cities.push(city);
                }
              });
            }
          });
        });
      });
    },
    handleUserRegistered({ user, userData, isGuest }) {
      this.newUser = user;
      // Store user data for later use in chooseRestoran
      this.newUser.userData = userData;

      if (isGuest) {
        this.loginGuest(userData.email, userData.password);
        this.showRestaurantDialog = false;
      } else {
        this.showRestaurantDialog = true;
      }
    },
    loginGuest(username, password) {
      userService
        .login(username, password)
        .then((res) => {
          localStorage.setItem("restoran-token", res.data.access_token);
          userService.getCurrentUser().then((res) => {
            this.sites = res.data.restaurants;
            this.$store.commit("user/SAVE_USER", res.data);
            if (res.data.restaurants && res.data.restaurants.length) {
              this.$store.commit("SAVE_RESTAURANT", res.data.restaurants[0]);
              this.$store.commit("SAVE_COMPANY", null);
              this.$store.commit("SAVE_COMPANIES", null);
            }
            if (res.data.companies && res.data.companies.length) {
              this.$store.commit("SAVE_COMPANY", res.data.companies[0]);
              this.$store.commit("SAVE_COMPANIES", res.data.companies);
              this.$store.commit("SAVE_RESTAURANT", null);
            }

            this.loading = false;
            this.routeName = this.$router.options.routes.find((i) =>
              i.roles.includes(res.data.type)
            );
            if (res.data.companies.length && res.data.companies[0].is_delivery) {
              this.$router.push({ name: "delivery" });
            } else if (this.sites.length === 1) {
              setTimeout(() => {
                this.$store.commit("SAVE_RESTAURANT", this.sites[0]);
                this.$router.push({ name: this.routeName.name });
              }, 300);
            } else this.$router.push({ name: "restorani-guest" });
          });
        })
        .catch(() => {
          this.loading = false;
          this.failed = true;
        });
    },
    handleShowSupport() {
      this.showSupportDialog = true;
    },
    handleToggleQR() {
      this.showQR = !this.showQR;
    },
    registerUser() {
      this.showRegisterDialog = true;
    },
    onDecode(decodedString) {
      let secure = JSON.parse(decodedString).secure;
      userService.loginWithHash(secure).then((res) => {
        localStorage.setItem("restoran-token", res.data.data.token);

        userService.getCurrentUser().then((res) => {
          this.sites = res.data.restaurants;
          this.$store.commit("user/SAVE_USER", res.data);
          if (res.data.restaurants.length) {
            this.$store.commit("SAVE_RESTAURANT", res.data.restaurants[0]);
            this.$store.commit("SAVE_COMPANY", null);
            this.$store.commit("SAVE_COMPANIES", null);
          }
          if (res.data.companies.length) {
            this.$store.commit("SAVE_COMPANY", res.data.companies[0]);
            this.$store.commit("SAVE_COMPANIES", res.data.companies);
            this.$store.commit("SAVE_RESTAURANT", null);
          }

          this.loading = false;
          this.failed = false;

          if (this.hasGroupMenu(res.data.companies) && this.user.type === "company") {
            this.$router.push({ name: "category-menu-group" });
          } else if (
            this.hasGroupMenu(res.data.companies) &&
            this.user.type != "recipient"
          ) {
            this.$router.push({ name: "category-menu" });
          } else if (res.data.companies.length && res.data.companies.is_delivery) {
            this.$router.push({ name: "delivery" });
          } else {
            this.$router.push({ name: "company-menu" });
          }
        });
      });
    },
    login() {
      this.loading = true;
      userService
        .login(this.email, this.password)
        .then((res) => {
          localStorage.setItem("restoran-token", res.data.access_token);

          userService.getCurrentUser().then((res) => {
            this.sites = res.data.restaurants;
            this.$store.commit("user/SAVE_USER", res.data);
            if (res.data.restaurants && res.data.restaurants.length) {
              this.$store.commit("SAVE_RESTAURANT", res.data.restaurants[0]);
              this.$store.commit("SAVE_COMPANY", null);
              this.$store.commit("SAVE_COMPANIES", null);
            }
            if (res.data.companies && res.data.companies.length) {
              this.$store.commit("SAVE_COMPANY", res.data.companies[0]);
              this.$store.commit("SAVE_COMPANIES", res.data.companies);
              this.$store.commit("SAVE_RESTAURANT", null);
            }

            this.loading = false;
            const userMenu = res.data?.user_menu?.menu1 ? JSON.parse(res.data.user_menu.menu1) : null;
            this.routeName = userMenu?.[0]?.to ?? null;
            if(!this.routeName) {
              this.routeName = this.$router.options.routes.find((i) =>
                i.roles.includes(res.data.type)
              );
            }
            if (this.hasGroupGoodMenu(res.data.companies)) {
              this.$router.push({ name: "category-menu-add" });
              return;
            }
            if (this.hasGroupMenu(res.data.companies) && this.user.type === "company") {
              this.$router.push({ name: "category-menu-group" });
              return;
            }
            // ako je kompanija type - 'group' i ako je user nije tip 'recipient' onda ga posalji na category-menu u suprotnom ga posalji na 'naplatu'
            if (this.hasGroupMenu(res.data.companies) && this.user.type != "recipient") {
              this.$router.push({ name: "category-menu" });
              return;
            }
            if (this.user.type == "rdminecipient") {
              this.$router.push({ name: "canteen" });
              return;
            }
            if (
              res.data.companies &&
              res.data.companies.length &&
              res.data.companies[0].is_delivery
            ) {
              this.$router.push({ name: "delivery" });
            } else if (this.sites.length === 1) {
              setTimeout(() => {
                this.$store.commit("SAVE_RESTAURANT", this.sites[0]);
                this.$router.push({ name: this.routeName.name });
              }, 300);
            } else this.$router.push({ name: this.routeName.name });
          });
        })
        .catch(() => {
          this.loading = false;
          this.failed = true;
        });
    },
    login2(username, password) {
      this.loading = true;
      userService
        .login(username, password)
        .then((res) => {
          localStorage.setItem("restoran-token", res.data.access_token);

          userService.getCurrentUser().then((res) => {
            this.sites = res.data.restaurants;
            this.$store.commit("user/SAVE_USER", res.data);
            if (res.data.restaurants && res.data.restaurants.length) {
              this.$store.commit("SAVE_RESTAURANT", res.data.restaurants[0]);
              this.$store.commit("SAVE_COMPANY", null);
              this.$store.commit("SAVE_COMPANIES", null);
            }
            if (res.data.companies && res.data.companies.length) {
              this.$store.commit("SAVE_COMPANY", res.data.companies[0]);
              this.$store.commit("SAVE_COMPANIES", res.data.companies);
              this.$store.commit("SAVE_RESTAURANT", null);
            }

            this.loading = false;
            this.routeName = this.$router.options.routes.find((i) =>
              i.roles.includes(res.data.type)
            );
            if (res.data.companies.length && res.data.companies[0].is_delivery) {
              this.$router.push({ name: "delivery" });
            } else if (this.sites.length === 1) {
              setTimeout(() => {
                this.$store.commit("SAVE_RESTAURANT", this.sites[0]);
                this.$router.push({ name: this.routeName.name });
              }, 300);
            } else this.$router.push({ name: this.routeName.name });
          });
        })
        .catch(() => {
          this.loading = false;
          this.failed = true;
        });
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
  watch: {
    "calculatedQr.status"() {
      if (typeof JSON.parse(this.calculatedQr.json) !== "number") {
        this.onDecode(this.calculatedQr.json);
      }
    },
  },
  mounted() {
    let _calculatedQr = this.calculatedQr;

    document.addEventListener(
      "keypress",
      function (event) {
        if (event.keyCode === 123) {
          _calculatedQr.status = true;
          _calculatedQr.json = null;
          _calculatedQr.arr = [];
        }
        if (_calculatedQr.status) {
          if (event.keyCode !== 13) _calculatedQr.arr.push(event.key);
          if (event.keyCode === 13) {
            _calculatedQr.json = _calculatedQr.arr.join("");
            _calculatedQr.status = false;
          }
        }
      },
      true
    );
  },
  beforeDestroy() {
    document.removeEventListener("keypress", function (event) {
      alert("izbrisan eventlistener");
    });
  },
};
</script>

<style>
.login {
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("@/assets/bg-home.webp");
  background-size: cover;
}

.login-box {
  margin-left: 100px;
  margin-top: 48px;
}

@media (max-width: 767px) {
  .v-input input,
  .veci-font {
    font-size: 16px !important;
  }
  .login-box {
    margin-left: 0px;
    margin-top: 0px;
  }
}
</style>
